export const ICON_PATHS = {
    user: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M4.5 20a7.5 7.5 0 0 1 15 0'],
    phone: [
        'M7.5 3.5h3l1.5 4-2 1.5a12 12 0 0 0 5 5l1.5-2 4 1.5v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 3.5 5.7 2 2 0 0 1 5.5 3.5Z',
    ],
    mail: ['M3.5 6.5h17v11h-17z', 'm3.5 7 8.5 6 8.5-6'],
    location: [
        'M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z',
        'M12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
    ],
    cake: ['M4 20.5h16v-7H4z', 'M6 13.5v-3h12v3', 'M12 10.5V7', 'M12 4.5v1'],
    globe: [
        'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
        'M3 12h18',
        'M12 3c2.5 2.6 3.8 5.7 3.8 9S14.5 18.4 12 21c-2.5-2.6-3.8-5.7-3.8-9S9.5 5.6 12 3Z',
    ],
    bell: ['M18 16V11a6 6 0 0 0-12 0v5l-1.5 2.5h15Z', 'M10 20.5a2.2 2.2 0 0 0 4 0'],
    camera: [
        'M3.5 8.5h3.2l1.6-2.5h7.4l1.6 2.5h3.2v11h-17z',
        'M12 16.8a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8Z',
    ],
    chevron: ['m9.5 5.5 6.5 6.5-6.5 6.5'],
    check: ['m4.5 12.5 5 5 10-10'],
    close: ['m5.5 5.5 13 13', 'm18.5 5.5-13 13'],
    plus: ['M12 4.5v15', 'M4.5 12h15'],
    edit: ['M4.5 19.5h4l10-10-4-4-10 10z', 'm14.5 5.5 4 4'],
    search: ['M11 18.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z', 'm16.5 16.5 4 4'],
    home: [
        // Same 24-unit grid, same 1.8 stroke: a roof over a body, with a door.
        'M3.5 10.5 12 4l8.5 6.5',
        'M5.5 9.5v10h13v-10',
        'M9.75 19.5v-5.5h4.5v5.5',
    ],
    car: [
        'M3.5 16.5v-3l2-5.5a2 2 0 0 1 1.9-1.3h9.2a2 2 0 0 1 1.9 1.3l2 5.5v3',
        'M3.5 13.5h17',
        'M6.5 16.5v2h-3v-2',
        'M20.5 16.5v2h-3v-2',
        'M7 10.5h10',
    ],
    // The vehicle family. Same feet, same baseline, same grid as `car`, so six
    // types in a row read as one set; only the silhouette changes — which is
    // the whole point of drawing them, since they used to share one glyph.
    suv: [
        // Taller, squarer body and a roof rail.
        'M3.5 16.5v-4.5l2-5a2 2 0 0 1 1.9-1.3h9.2a2 2 0 0 1 1.9 1.3l2 5v4.5',
        'M3.5 13h17',
        'M6.5 16.5v2h-3v-2',
        'M20.5 16.5v2h-3v-2',
        'M7.5 4.8h9',
        'M8 9.5h8',
    ],
    van: [
        // A box with a raked windscreen and a side window.
        'M3.5 16.5v-8.5a1.5 1.5 0 0 1 1.5-1.5h8.5l4 4h2.5a.5.5 0 0 1 .5.5v5.5',
        'M13.5 6.5v4h4',
        'M3.5 12.5h17',
        'M6.5 16.5v2h-3v-2',
        'M20.5 16.5v2h-3v-2',
    ],
    truck: [
        // A cab and a flat bed.
        'M3.5 16.5v-8h9.5v8',
        'M13 16.5v-5h3.5l3 3v2',
        'M3.5 16.5h17',
        'M6.5 16.5v2h-3v-2',
        'M20.5 16.5v2h-3v-2',
    ],
    motorcycle: [
        // Two wheels, a frame, a bar.
        'M4 16.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0',
        'M15 16.5a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0',
        'M6.5 16.5l3-5.5h4.5l3.5 5.5',
        'M13 8.5h3l1.5 2.5',
        'M11.5 11h-4',
    ],
    bus: [
        // Long body, a row of windows, and feet set wide.
        'M3 16.5v-9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9',
        'M3 12.5h18',
        'M7.5 5.5v7',
        'M12 5.5v7',
        'M16.5 5.5v7',
        'M6.5 16.5v2h-3v-2',
        'M20.5 16.5v2h-3v-2',
    ],
    // For banners. Drawn rather than typed as ⚠️/ℹ️, which render as platform
    // emoji in fixed colours and ignore the tone they sit in.
    alert: ['M12 4.5l8.5 15h-17z', 'M12 10v4', 'M12 17.2v.3'],
    info: ['M12 3.5a8.5 8.5 0 1 0 0 17a8.5 8.5 0 1 0 0-17', 'M12 11v5', 'M12 7.8v.3'],
    // The password-reveal toggle. Was 🙈/👁, which on one platform is a monkey
    // and on another a bare eyeball, and neither takes the field's colour.
    eye: [
        'M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12z',
        'M9.5 12a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0-5 0',
    ],
    'eye-off': [
        'M2.5 12s3.5-6.5 9.5-6.5c1.4 0 2.7.3 3.8.9',
        'M21.5 12s-3.5 6.5-9.5 6.5c-1.4 0-2.7-.3-3.8-.9',
        'M9.5 12a2.5 2.5 0 0 0 3.5 2.3',
        'M4 4l16 16',
    ],
    oil: ['M12 3.5c0 0 6 6.6 6 10.7A6 6 0 0 1 6 14.2C6 10.1 12 3.5 12 3.5Z'],
    wrench: [
        'M15.5 4.5a5 5 0 0 0-4.6 7l-6.4 6.4 2.6 2.6 6.4-6.4a5 5 0 0 0 6-6.8L17 10.2l-2.5-.7-.7-2.5Z',
    ],
    gauge: ['M4.5 17.5a9 9 0 1 1 15 0', 'm12 12 4-3.5', 'M12 17.5v.01'],
    fuel: [
        'M5 20.5V5.2A1.7 1.7 0 0 1 6.7 3.5h5.6A1.7 1.7 0 0 1 14 5.2v15.3',
        'M4 20.5h11',
        'M6.5 9.5h6',
        'M17 8.5l2.5 2.5v6a1.5 1.5 0 0 1-3 0V8.5Z',
    ],
    gear: [
        'M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z',
        'M12 2.8v2.4',
        'M12 18.8v2.4',
        'M4.5 12H2.1',
        'M21.9 12h-2.4',
        'm6.7 6.7-1.7-1.7',
        'm19 19-1.7-1.7',
        'm6.7 17.3-1.7 1.7',
        'm19 5-1.7 1.7',
    ],
    calendar: ['M4.5 6.5h15v14h-15z', 'M4.5 11h15', 'M8.5 3.5v4', 'M15.5 3.5v4'],
    wallet: [
        'M3.5 7.5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-14z',
        'M3.5 7.5v-2a1 1 0 0 1 1-1H15',
        'M16 13.5v.01',
    ],
    gift: [
        'M4 11.5h16v9H4z',
        'M3.5 7.5h17v4h-17z',
        'M12 7.5v13',
        'M12 7.5S10.5 3.5 8 3.5a2 2 0 0 0 0 4Z',
        'M12 7.5S13.5 3.5 16 3.5a2 2 0 0 1 0 4Z',
    ],
    store: [
        'M4 10.5v10h16v-10',
        'M3 10.5 5 4.5h14l2 6a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0Z',
        'M10 20.5v-6h4v6',
    ],
    shield: ['M12 3.5 5 6v6c0 4.4 3 7.6 7 8.5 4-.9 7-4.1 7-8.5V6Z', 'm9 12 2.2 2.2L15 10.5'],
    logout: ['M14.5 4.5h-8v15h8', 'M11 12h9.5', 'm17.5 8.5 3.5 3.5-3.5 3.5'],
    sparkle: [
        'M12 3.5 13.8 9 19.5 10.8 13.8 12.6 12 18.2l-1.8-5.6L4.5 10.8 10.2 9Z',
        'M18.5 16.5l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7Z',
    ],
    // Three finder squares and a dotted quadrant: read as "a QR" at 16px.
    qr: [
        'M4 4h6v6H4z',
        'M14 4h6v6h-6z',
        'M4 14h6v6H4z',
        'M14 14h2v2h-2z',
        'M18 14h2v2h-2z',
        'M14 18h2v2h-2z',
        'M18 18h2v2h-2z',
    ],
    clock: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M12 7v5.2l3.2 1.9'],
    // Service catalogue categories. Keys match the backend's `icon` values.
    filter: ['M4.5 6.5h15', 'M6.5 12h11', 'M9 17.5h6'],
    tire: [
        'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
        'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
        'M12 3v5',
        'M12 16v5',
        'M3 12h5',
        'M16 12h5',
    ],
    brake: [
        'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
        'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z',
        'M12 12h.01',
    ],
    bolt: ['M13 3 5 13.5h6l-1 7.5 8-10.5h-6z'],
    wiper: ['M4 18.5 12 6l8 12.5', 'M4 18.5h16', 'M12 6v-2'],
    engine: ['M6.5 9h9l2 2h2v7h-2l-2 2h-6l-2-2H5V11h1.5z', 'M9 5.5h5', 'M11.5 5.5V9', 'M3.5 13v3'],
    suspension: ['M8 3v18', 'M16 3v18', 'M8 8h8', 'M8 16h8', 'M5.5 12h13'],
    snowflake: [
        'M12 3v18',
        'M4.2 7.5l15.6 9',
        'M4.2 16.5l15.6-9',
        'M12 3l-2 2M12 3l2 2',
        'M12 21l-2-2M12 21l2-2',
    ],
    map: ['M3.5 6.5v13l5.5-2 6 2 5.5-2v-13l-5.5 2-6-2z', 'M9 4.5v13', 'M15 6.5v13'],
    chat: ['M4.5 5.5h15v10h-8l-4.5 3.5v-3.5h-2.5z', 'M8.5 10.5h7'],
    tag: ['M3.5 12.5v-8h8l9 9-8 8z', 'M7.5 8.5h.01'],
    receipt: [
        'M6 3.5h12v17l-2-1.5-2 1.5-2-1.5-2 1.5-2-1.5-2 1.5z',
        'M9 8.5h6',
        'M9 12h6',
        'M9 15.5h4',
    ],
    funnel: ['M3.5 5.5h17l-6.5 7.5v5.5l-4 2v-7.5z'],
    history: ['M4 12a8 8 0 1 0 2.3-5.6', 'M4 4v4.5h4.5', 'M12 8v4.5l3 1.8'],
    link: [
        'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7L11.5 6.8',
        'M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1.5-1.5',
    ],
    dashboard: ['M4 4h7v9H4z', 'M13 4h7v5h-7z', 'M13 11h7v9h-7z', 'M4 15h7v5H4z'],
    users: [
        'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
        'M2.5 19.5a6.5 6.5 0 0 1 13 0',
        'M16 4.3a3.5 3.5 0 0 1 0 6.4',
        'M18 13.6a6.5 6.5 0 0 1 3.5 5.9',
    ],
    'user-check': ['M10 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M3 20a7 7 0 0 1 11-5.7', 'm15 18 2 2 4-4'],
    chart: ['M4 20V10', 'M10 20V4', 'M16 20v-7', 'M3 20.5h18'],
    activity: ['M3 12h4l2.5-6 5 12 2.5-6h4'],
    'trend-up': ['m3.5 17 6-6 4 4 7-7', 'M15 8h5.5v5.5'],
    package: ['M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z', 'M3.5 7.5 12 12l8.5-4.5', 'M12 12v9'],
    warehouse: ['M3 20.5V9l9-5 9 5v11.5', 'M7 20.5v-8h10v8', 'M7 16.5h10'],
    layers: ['m12 3 9 5-9 5-9-5z', 'm3 12.5 9 5 9-5', 'm3 16.5 9 5 9-5'],
    swap: ['M7 4.5 3.5 8 7 11.5', 'M3.5 8h13', 'm17 12.5 3.5 3.5-3.5 3.5', 'M20.5 16h-13'],
    banknote: [
        'M3 6.5h18v11H3z',
        'M12 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
        'M6.5 9.5v5',
        'M17.5 9.5v5',
    ],
    list: ['M8.5 6h12', 'M8.5 12h12', 'M8.5 18h12', 'M4 6h.01', 'M4 12h.01', 'M4 18h.01'],
    sliders: [
        'M4 6h9',
        'M17 6h3',
        'M4 12h3',
        'M11 12h9',
        'M4 18h11',
        'M19 18h1',
        'M15 4v4',
        'M9 10v4',
        'M17 16v4',
    ],
    menu: ['M4 6.5h16', 'M4 12h16', 'M4 17.5h16'],
    sidebar: ['M3.5 4.5h17v15h-17z', 'M9.5 4.5v15'],
    sun: [
        'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
        'M12 2.5v2',
        'M12 19.5v2',
        'm4.6 4.6 1.4 1.4',
        'm18 18 1.4 1.4',
        'M2.5 12h2',
        'M19.5 12h2',
        'm4.6 19.4 1.4-1.4',
        'm18 6 1.4-1.4',
    ],
    moon: ['M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5Z'],
    monitor: ['M3.5 4.5h17v11h-17z', 'M8.5 20h7', 'M12 15.5V20'],
    copy: ['M8.5 8.5h11v11h-11z', 'M15.5 8.5v-4h-11v11h4'],
    external: ['M14 4.5h5.5V10', 'M19.5 4.5 11 13', 'M18 14v5.5H4.5V6H10'],
    trash: ['M4.5 6.5h15', 'M9.5 6.5v-2h5v2', 'm6.5 6.5 1 13h9l1-13', 'M10 10.5v6', 'M14 10.5v6'],
    refresh: ['M20 12a8 8 0 1 1-2.3-5.6', 'M20 4v4.5h-4.5'],
    download: ['M12 4v11', 'm7.5 10.5 4.5 4.5 4.5-4.5', 'M4.5 19.5h15'],
    more: ['M5 12h.01', 'M12 12h.01', 'M19 12h.01'],
    arrow: ['M4.5 12h15', 'm13.5 6 6 6-6 6'],
    'check-circle': ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'm8 12.5 2.8 2.8 5.2-5.6'],
    briefcase: ['M3.5 7.5h17v12h-17z', 'M8.5 7.5v-3h7v3', 'M3.5 12.5h17'],
    lock: ['M6.5 10.5h11v10h-11z', 'M8.5 10.5v-3a3.5 3.5 0 0 1 7 0v3'],
    sort: ['M7 4v16', 'M3.5 7.5 7 4l3.5 3.5', 'M17 20V4', 'm13.5 16.5 3.5 3.5 3.5-3.5'],
    minus: ['M4.5 12h15'],
    flag: ['M5 21V4', 'M5 4.5h11l-2 4 2 4H5'],
    star: ['m12 3.5 2.6 5.4 5.9.8-4.3 4.1 1 5.8-5.2-2.8-5.2 2.8 1-5.8-4.3-4.1 5.9-.8z'],
    droplet: ['M12 3.5s6.5 7 6.5 11a6.5 6.5 0 0 1-13 0c0-4 6.5-11 6.5-11Z'],
};
/** Every icon name, for tests and for pickers. */
export const ICON_NAMES = Object.keys(ICON_PATHS);
/**
 * Glyphs that point somewhere. They mirror in a right-to-left interface,
 * because "forward" is leftwards in Arabic; everything else keeps its drawing.
 */
export const DIRECTIONAL_ICONS = ['chevron', 'arrow', 'logout'];
/** Icons that are a closed shape and read better with a soft fill. */
export const FILLED_ICONS = ['oil', 'droplet'];
//# sourceMappingURL=icons.js.map